import React from 'react';
import facebook from "../../Images/facebook.png";
import whatsapp from "../../Images/Whatsapp Icon.png";
import mssngr from "../../Images/Messenger.png";
import linkedin from "../../Images/Linkedin.png";
import xcom from "../../Images/Xcom.png";
import email from "../../Images/Email.png";

const QRprofileShare = ({ closeProfile }) => {

    const loop = [{ id: 1, name: 'Facebook', img: facebook, }, { id: 2, name: 'Whatsapp', img: whatsapp, }, { id: 3, name: 'Messenger', img: mssngr, }, { id: 4, name: 'Linkedin', img: linkedin, }, { id: 5, name: 'X.com', img: xcom, }, { id: 6, name: 'Email', img: email, },];

    return (
        <>
            <section className="prflShrModSec">
                <div className="prflshrModInn">
                    <div className="ModClosebtn" onClick={() => closeProfile()}>
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                    <div className="prflShrIcon">
                        {loop.map((item, index) => {
                            return (
                                <div className="prflshrDiv" key={index}>
                                    <figure className='prflshrFig'>
                                        <img src={item.img} alt="img" />
                                    </figure>
                                    <p className='prflshrnm'>{item.name}</p>
                                </div>
                            )
                        })}

                    </div>

                </div>
            </section>
        </>
    )
}

export default QRprofileShare